/* eslint-disable @typescript-eslint/no-explicit-any */
import BankApi from '@portal/repositories/bank';
import * as MessageService from '~/services/message';

import { BANK_DETAILS, BANK_LIST } from './actionTypes';
import { decreaseLoading, increaseLoading } from './loading';
import centralNavigationService from '~/services/navigation';

export const getBanks = () => async (dispatch: any) => {
  dispatch(increaseLoading());
  try {
    const payload: models.PaginationResponse<models.Bank> =
      await BankApi.getBanks();

    dispatch({
      payload,
      type: BANK_LIST,
    });
  } catch (err: any) {
    MessageService.error(err.message, { originalError: err });
  } finally {
    dispatch(decreaseLoading());
  }
};

export const getBankDetails = (id: string) => async (dispatch: any) => {
  dispatch(increaseLoading());
  try {
    const payload: models.Bank = await BankApi.getBankDetails(id);

    dispatch({
      payload,
      type: BANK_DETAILS,
    });
  } catch (err: any) {
    MessageService.error(err.message, { originalError: err });
  } finally {
    dispatch(decreaseLoading());
  }
};

export const createBank = (params: models.Bank) => async (dispatch: any) => {
  dispatch(increaseLoading());
  try {
    await BankApi.createBank(params);
    MessageService.success(
      'PAGES.PANEL.BANK_REPORT.MESSAGE.SUCCESS_CREATE_BANK'
    );
    centralNavigationService.back();
  } catch (err: any) {
    MessageService.error(err.message, { originalError: err });
  } finally {
    dispatch(decreaseLoading());
  }
};

export const updateBank =
  (params: models.Bank, id: string) => async (dispatch: any) => {
    dispatch(increaseLoading());
    try {
      await BankApi.updateBank(params, id);
      MessageService.success(
        'PAGES.PANEL.BANK_REPORT.MESSAGE.SUCCESS_UPDATE_BANK'
      );
    } catch (err: any) {
      MessageService.error(err.message, { originalError: err });
    } finally {
      dispatch(decreaseLoading());
    }
  };

export const deleteBank = (id: string) => async (dispatch: any) => {
  dispatch(increaseLoading());
  try {
    await BankApi.deleteBank(id);
    MessageService.success(
      'PAGES.PANEL.BANK_REPORT.MESSAGE.SUCCESS_DELETE_BANK'
    );
    centralNavigationService.back();
  } catch (err: any) {
    MessageService.error(err.message, { originalError: err });
  } finally {
    dispatch(decreaseLoading());
  }
};
